<template lang="html">
  <page-panel :titles="['认证中心','个人提现认证']" style="margin-top: 90px;">
      <el-form class="page-element"  :hide-required-asterisk="true"  :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="100px" :model="formData">
            <div class="tips">
                 提现银行卡绑定需先完成实名认证，认证通过后，请绑定该认证主体名下的银行卡。如需更改认证主体，请联系客服！
             </div>
          <el-form-item  label="持卡人">
              <span>{{formData.realName}}</span>
          </el-form-item>
          <el-form-item label="开户银行"  prop="bankName">
              <el-select v-model="formData.bankName" placeholder="请选择银行">
                <el-option
                    v-for="item in bankList"
                    :key="item.bankCode"
                    :label="item.bankName"
                    :value="item.bankCode">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="开户地区"  prop="city" class="address-column-2">
             <el-select v-model="formData.province" placeholder="全国">
               <el-option
                   v-for="item in provinceList"
                   :key="item.value"
                   :label="item.name"
                   :value="item.value">
               </el-option>
             </el-select>
             <el-select v-model="formData.city" placeholder="请选择市">
               <el-option
                   v-for="item in cityList"
                   :key="item.value"
                   :label="item.name"
                   :value="item.value">
               </el-option>
             </el-select>
          </el-form-item>
          <el-form-item label="收款账号" prop="bankAccount" :error="errors.bankAccount">
            <el-input v-model="formData.bankAccount"
            placeholder="请输入银行卡号并仔细核对"
             @keypress.enter.native="submit()"></el-input>
         </el-form-item>
         <el-form-item label="预留手机号" prop="phone" :error="errors.phone">
           <el-input v-model="formData.phone"
           placeholder="请输入此卡在银行预留的手机号"
            @keypress.enter.native="submit()"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code"  class="code_input"  :error="errors.code">
          <el-input v-model="formData.code"
          placeholder="请输入验证码"
           @keypress.enter.native="submit()"></el-input>
           <span class="codeBtn" :class="{light:codeTip === '获取验证码'}" @click="onGetCode">{{codeTip}}</span>
        </el-form-item>
      </el-form>

     <footer class="footer">
         <app-button  class="medium" @click="$router.push({path:'/advanced'})">取消</app-button>
         <app-button  class="medium" type="primary"  @click="submit">提交</app-button>
     </footer>
  </page-panel>
</template>

<script>
import pagePanel from 'components/Panel/pagePanel.vue'
import { addressMixin } from 'utils/mixins'
import { identPhone } from 'api/account'
import appButton from 'components/Button/index'
import codeMixin from 'mixins/codeMixin'
import baseMixin from './pops/realName/baseMixin'
import { validateBankCard, getUserBankInfo, getBankList, modifyBankCertification } from 'api/certification'

export default {
    mixins: [baseMixin, addressMixin, codeMixin],
    data () {
        let validateBankAccount = (rule, value, callback) => {
            const params = Object.assign({}, this.formData)
            validateBankCard(params).then(res => {
                if (res.data.success) {
                    callback()
                } else {
                    const message = res.data.msg ? res.data.msg : '卡号与所选开户银行不符，请核查信息重新填写'
                    callback(new Error(message))
                }
            })
        }

        return {
            formData: {
                bankAccount: '',
                bankName: ''
            },
            errors: {
                code: '',
                phone: '',
                bankAccount: ''
            },
            rules: {
                bankName: [{ required: true, message: '请选择银行', trigger: 'change' }],
                city: [{ required: true, message: '地址不能为空', trigger: 'change' }],
                bankAccount: [{ required: true, message: '收款账号不能为空', trigger: 'blur' },
                    {
                        validator: validateBankAccount,
                        trigger: 'blur'
                    }
                ]
            },
            bankList: [],
            bindPhoneCode: true // 控制注册码
        }
    },
    created () {
        this.getBankList()
        this.getUserBankInfo()
    },
    methods: {
        getUserBankInfo () {
            getUserBankInfo({ type: 1 }).then(res => {
                if (res.data.success) {
                    let {
                        bankProvince: province,
                        bankCity: city,
                        bankPhone: phone
                    } = res.data.obj
                    let obj = { province, city, phone }
                    this.initAddress({ data: { obj } })
                    this.formData = Object.assign({}, res.data.obj, obj)
                }
            })
        },
        getBankList () {
            getBankList().then(res => {
                if (res.data.success) {
                    this.bankList = res.data.list
                }
            })
        },
        onGetCode () {
            if (this.formData.phone) {
                this.errors.phone = ''
                this.triggerCode()
            } else {
                this.errors.phone = '请输入银行预留手机号'
            }
        },
        submit () {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return false
                }
                this.errors.bankAccount = ''
                this.errors.phone = ''
                this.errors.code = ''

                const params = Object.assign({}, this.formData)
                identPhone(params).then(res => {
                    const code = res.data.code
                    if (code !== 200) {
                        this.errors.code = res.data.msg
                    } else {
                        this.modifyBankCertification()
                    }
                })
            })
        },
        modifyBankCertification () {
            const params = Object.assign({}, this.formData)
            params.bankPhone = this.formData.phone
            params.bankProvince = this.formData.province
            params.bankCity = this.formData.city
            modifyBankCertification(params).then((res) => {
                if (res.data.code === 200) {
                    this.$alert({
                        title: '提交成功',
                        type: 'success',
                        message: '请耐心等待，审核结果会以站内信形式发送。'
                    }).then(() => {
                        this.$router.push({ path: '/advanced/index' })
                    })
                } else {
                    this.$alert({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            })
        }
    },
    components: {
        pagePanel, appButton
    }
}
</script>

<style lang="scss"  scoped="true" >
.page-element{
    margin-top: 22px !important;
}
.footer{
    text-align: center;
    border-top: 1px solid #E6EBED;
    padding-top: 40px;
}
</style>
